import { timestamp_to_date } from '@/utils/time';
import { PersonSchema } from '@/views/cases/data/schema';
export type { Person } from '@/views/cases/data/schema';
import { z } from 'zod'

export const ClientTypeEnum = z.enum(['individual', 'corporate']);
export type ClientType = z.infer<typeof ClientTypeEnum>;

export const IdTypeEnum = z.enum(['cin', 'passport', 'residence_card']);
export type IdType = z.infer<typeof IdTypeEnum>;

export const LegalFormEnum = z.enum(['sarl', 'sa', 'sas', 'snc', 'auto', 'other']);
export type LegalForm = z.infer<typeof LegalFormEnum>;

export const clientSchema = z.object({
  id: z.string(),
  // Core Info
  name: z.string(), // Full Name (Individual) or Company Name (Corporate)
  client_type: ClientTypeEnum.default('individual'),
  
  // Contact Info
  email: z.string().nullable(),
  phone: z.string().nullable(),
  address: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  
  // Identification
  idnumber: z.string().nullable(), // CIN or ICE
  
  // Individual Specific
  id_type: IdTypeEnum.nullable().optional(),
  birth_date: z.string().nullable().optional(), // YYYY-MM-DD
  nationality: z.string().nullable().optional(),
  profession: z.string().nullable().optional(),
  
  // Corporate Specific
  legal_form: LegalFormEnum.nullable().optional(),
  rc_number: z.string().nullable().optional(), // Registre de Commerce
  rc_city: z.string().nullable().optional(),   // Ville du Tribunal
  if_number: z.string().nullable().optional(), // Identifiant Fiscal
  activity_sector: z.string().nullable().optional(),
  legal_representative: z.string().nullable().optional(),
  representative_role: z.string().nullable().optional(),
  company_creation_date: z.string().nullable().optional(), // YYYY-MM-DD

  // Metadata
  notes: z.string().nullable().optional(),
  added_by: PersonSchema,
  created_at: z.number().transform(timestamp_to_date),
  updated_at: z.number().optional().transform((val) => val ? timestamp_to_date(val) : undefined)
})
export type Client = z.infer<typeof clientSchema>

export const clientListSchema = z.array(clientSchema)
